interface CachedContent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any; // yeah I know  |  Seriously bro ??
  timestamp: number;
}

const BASE_TTL = 30_000; // TTL in milliseconds - 1 minute
const SESSION_TTL = 5_000;

const ignoreCache = () => {
  // not used now, but we can define some rules to ignore cache for some requests
  return false;
};

const getTTL = (key: string) => {
  if (key.includes('sessions')) {
    return SESSION_TTL;
  }

  return BASE_TTL;
};

class RequestCacheClass {
  cache: Record<string, CachedContent> = {};

  private cacheKeys = new Set<string>();

  private static _instance: RequestCacheClass;

  public static get instance(): RequestCacheClass {
    if (!RequestCacheClass._instance) {
      RequestCacheClass._instance = new RequestCacheClass();
    }

    return RequestCacheClass._instance;
  }

  public get<T>(key: string): T | undefined {
    if (!ignoreCache() && this.cacheKeys.has(key)) {
      if (Date.now() - this.cache[key].timestamp < getTTL(key)) {
        return this.cache[key].data;
      }
      this.deleteCache(key);
    }

    return undefined;
  }

  public set<T>(key: string, value: T): void {
    this.cacheKeys.add(key);
    this.cache[key] = {
      timestamp: Date.now(),
      data: value,
    };
  }

  private deleteCache(key: string): void {
    this.cacheKeys.delete(key);
    delete this.cache[key];
  }

  public clearAllCache(): void {
    this.cacheKeys.clear();
    this.cache = {};
  }
}

export const RequestCache = RequestCacheClass.instance;

export function cacheRequest<T>(
  key: string,
  request: () => Promise<T>,
  withCache = true,
): Promise<T> {
  const cachedValue = RequestCache.get<T>(key);
  if (cachedValue) {
    return Promise.resolve(cachedValue);
  }

  return request().then((value) => {
    if (withCache) {
      RequestCache.set(key, value);
    }
    return value;
  });
}
